// Urgent request audio alert using Web Audio API
let audioContext = null;

function getAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
}

export function playUrgentAlert() {
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;

    // Two-tone alert: high-low-high pattern
    const frequencies = [880, 660, 880, 660, 880];
    const duration = 0.12;
    const gap = 0.06;

    frequencies.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.type = "square";
      osc.frequency.value = freq;

      const start = now + i * (duration + gap);
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.15, start + 0.01);
      gain.gain.setValueAtTime(0.15, start + duration - 0.01);
      gain.gain.linearRampToValueAtTime(0, start + duration);

      osc.start(start);
      osc.stop(start + duration);
    });
  } catch (e) {
    // Audio API not available
  }
}

export function playNewRequestChime() {
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.type = "sine";
    osc.frequency.setValueAtTime(523, now);
    osc.frequency.setValueAtTime(659, now + 0.1);
    osc.frequency.setValueAtTime(784, now + 0.2);

    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.12, now + 0.02);
    gain.gain.setValueAtTime(0.12, now + 0.25);
    gain.gain.linearRampToValueAtTime(0, now + 0.35);

    osc.start(now);
    osc.stop(now + 0.35);
  } catch (e) {
    // Audio API not available
  }
}
